const defaultTShirtFormObject = {
    id: '',
    sizeName: '',
    chest: {
        cm: '',
        in: '',
    },
    frontLength: {
        cm: '',
        in: '',
    },
    shoulder: {
        cm: '',
        in: '',
    },
    sleeveLength: {
        cm: '',
        in: '',
    },
};

const defaultTrousersFormObject = {
    id: '',
    sizeName: '',
    waist: {
        cm: '',
        in: '',
    },
    hip: {
        cm: '',
        in: '',
    },
    inseam: {
        cm: '',
        in: '',
    },
    outseam: {
        cm: '',
        in: '',
    },
};

const defaultWomenDressFormObject = {
    id: '',
    sizeName: '',
    bust: {
        cm: '',
        in: '',
    },
    waist: {
        cm: '',
        in: '',
    },
    hip: {
        cm: '',
        in: '',
    },
    frontLength: {
        cm: '',
        in: '',
    },
};

const defaultCoatsFormObject = {
    id: '',
    sizeName: '',
    chest: {
        cm: '',
        in: '',
    },
    frontLength: {
        cm: '',
        in: '',
    },
    shoulder: {
        cm: '',
        in: '',
    },
};

const defaultShoeFormObject = {
    id: '',
    UK: {
        sizeName: 'UK',
        cm: '',
        in: '',
    },
    US: {
        sizeName: 'US',
        cm: '',
        in: '',
    },
    EURO: {
        sizeName: 'EURO',
        cm: '',
        in: '',
    },
    toFitFootLength: {
        sizeName: 'To Fit Foot Length',
        cm: '',
        in: '',
    },
};

const defaultHeelFormObject = {
    id: '',
    UK: {
        sizeName: 'UK',
        cm: '',
        in: '',
    },
    US: {
        sizeName: 'US',
        cm: '',
        in: '',
    },
    EURO: {
        sizeName: 'EURO',
        cm: '',
        in: '',
    },
    toFitFootLength: {
        sizeName: 'To Fit Foot Length',
        cm: '',
        in: '',
    },
    heelToToe: {
        sizeName: 'Heel to Toe',
        cm: '',
        in: '',
    },
};

const defaultClothingSetFormObject = {
    id: '',
    sizeName: '',
    chest: {
        cm: '',
        in: '',
    },
    frontLength: {
        cm: '',
        in: '',
    },
    shoulder: {
        cm: '',
        in: '',
    },
    sleeveLength: {
        cm: '',
        in: '',
    },
    waist: {
        cm: '',
        in: '',
    },
    hip: {
        cm: '',
        in: '',
    },
    inseam: {
        cm: '',
        in: '',
    },
    outseam: {
        cm: '',
        in: '',
    },
};

const sizeOptions = [
    {
        id: 'xxxs',
        title: 'XXXS'
    },
    {
        id: 'xxs',
        title: 'XXS'
    },
    {
        id: 'xs',
        title: 'XS'
    },
    {
        id: 's',
        title: 'S'
    },
    {
        id: 'm',
        title: 'M'
    },
    {
        id: 'l',
        title: 'L'
    },
    {
        id: 'xl',
        title: 'XL'
    },
    {
        id: 'xxl',
        title: '2XL'
    },
    {
        id: 'xxxl',
        title: '3XL'
    },
    {
        id: 'xxxxl',
        title: '4XL'
    },
    {
        id: 'xxxxxl',
        title: '5XL'
    },
]

function getDefaultFormObjectByCategory(category) {
    switch (category) {
        case 'T-Shirt, Shirt, Top':
            return defaultTShirtFormObject;
        case 'Trousers, Phants, Jeans':
            return defaultTrousersFormObject;
        case 'Women Dresses':
            return defaultWomenDressFormObject;
        case 'Coat & Jacket':
            return defaultCoatsFormObject;
        case 'Shoe & Sandals':
            return defaultShoeFormObject;
        case 'High Heels':
            return defaultHeelFormObject;
        case 'Clothing Set':
            return defaultClothingSetFormObject;
        default:
            return null;
    }
}

export {
    defaultTShirtFormObject,
    defaultTrousersFormObject,
    defaultWomenDressFormObject,
    defaultCoatsFormObject,
    defaultShoeFormObject,
    defaultHeelFormObject,
    defaultClothingSetFormObject,
    getDefaultFormObjectByCategory,
    sizeOptions,
};
